import {h, Fragment} from "preact"
import {
  useResponse,
  AutocompleteElement,
  Keywords,
  useCurrencyFormatting,
} from '@nosto/preact';

import { productImagePlaceholder } from '../helpers';
import SubmitButton from './elements/SubmitButton';
import History from './History';

export default function Autocomplete() {
  const { products, keywords } = useResponse();
  const { format } = useCurrencyFormatting();

  if (!products?.hits?.length && !keywords?.hits?.length) {
    return;
  }

  return (
    <div
      data-nosto-element="autocomplete"
      class="nsc_autocomplete acs_auto_popup acs_scroll"
    >
      <div class="acs_auto">
        {/* <div class="acs_auto_col1">
          <h4>Recent Searches</h4>
          <ul>{<History />}</ul> */}
        {/* {keywords?.hits?.length > 0 && (
            <div class="acs_auto_col2">
              <h4>
                Products<a href="/search?q=mens">View all</a>
              </h4>

              <Keywords
                hits={keywords.hits}
                keywordComponent={Keyword}
                elementComponent={Element}
                keywordInCategoryComponent={KeywordInCategory}
              />

              {!products?.hits?.length && (
                <SubmitButton text="See all search results" />
              )}
            </div>
          )} */}
        {/* </div> */}
        {products?.hits?.length > 0 && (
          <>
            <div class="acs_auto_col1">
              <h4>Recent Searches</h4>
              <ul>{<History />}</ul>
              <h4>Can we help?</h4>
              <ul class="acs_auto_help">
                <li>
                  <a href="/pages/faqs">FAQs</a>
                </li>
                <li>
                  <a href="/pages/shipping">Shipping</a>
                </li>
                <li>
                  <a href="/pages/returns-1">Returns</a>
                </li>
              </ul>
            </div>
            <div class="acs_auto_col2">
              <h4 class="nsc-autocomplete-right-top-bar ns-d-flex ns-justify-content-between ">
                Products
                <SubmitButton
                  className="ns-text-underline ns-text-uppercase ns-font-bold"
                  text="View all"
                />
              </h4>
              <ul class="acs_auto_prods acs_auto_prods_size_6">
              {products?.hits
                ?.filter((hit) => !hit.tags1?.includes('nosto-ignore')) // Filter out products with 'nosto-ignore' tag
                .map((hit) => {
                  return (
                    <AutocompleteElement hit={hit}>
                      <div
                        data-url={hit.url}
                        class="acs_auto_prod "
                        data-nosto-element="product"
                      >
                        <div class="grid__item grid-product">
                          <div class="grid-product__content">
                            <div class="grid__item-image-wrapper">
                              <div class="grid-product__image-mask">
                                <a
                                  class="grid-product__link"
                                  href={hit.url}
                                  aria-label={hit.name}
                                >
                                  <div class="gc_product_item_image-wrapper image-wrap">
                                    <svg
                                      class="gc_product_item_placeholder"
                                      version="1.0"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="525.000000pt"
                                      height="525.000000pt"
                                      viewBox="0 0 525.000000 525.000000"
                                      preserveAspectRatio="xMidYMid meet"
                                    >
                                      <g
                                        transform="translate(0.000000,525.000000) scale(0.100000,-0.100000)"
                                        fill="#000000"
                                        stroke="none"
                                      >
                                        <path d="M220 3068 l0 -153 150 150 c83 82 150 151 150 152 0 2 -67 3 -150 3 l-150 0 0 -152z"></path>
                                        <path d="M1255 3070 c82 -82 151 -150 152 -150 2 0 3 68 3 150 l0 150 -152 0 -153 0 150 -150z"></path>
                                        <path d="M1786 3076 c-26 -79 -46 -149 -46 -155 0 -8 52 -11 170 -11 94 0 170 -2 170 -4 0 -2 -61 -198 -135 -436 -74 -238 -135 -437 -135 -442 0 -5 77 -7 172 -6 l172 3 137 440 136 440 90 3 90 3 6 -167 c4 -92 7 -235 7 -318 0 -83 3 -208 7 -279 l6 -127 156 2 155 3 206 313 205 312 6 -51 c4 -28 10 -169 14 -315 l8 -264 160 2 160 3 303 474 c167 261 304 471 304 467 0 -6 -229 -750 -286 -928 -5 -17 21 -18 449 -18 l454 0 53 153 c29 83 55 158 57 165 4 9 -55 12 -276 12 -155 0 -281 1 -281 3 0 1 58 196 129 432 l129 430 -322 3 c-297 2 -322 1 -334 -15 -7 -10 -97 -156 -200 -326 l-187 -307 -7 82 c-3 46 -6 171 -7 279 -1 108 -4 217 -7 243 l-7 46 -146 0 -146 0 -205 -322 -205 -322 -3 322 -2 322 -565 0 -564 0 -45 -144z"></path>
                                        <path d="M547 2893 l-57 -58 107 -107 108 -108 -108 -108 -107 -107 57 -58 58 -57 107 107 108 108 105 -105 105 -105 57 57 57 57 -104 106 -104 105 104 105 104 106 -57 57 -57 57 -105 -105 -105 -105 -108 108 -107 107 -58 -57z"></path>
                                        <path d="M220 2170 l0 -150 152 0 153 0 -150 150 c-82 83 -151 150 -152 150 -2 0 -3 -67 -3 -150z"></path>
                                        <path d="M1255 2170 l-150 -150 153 0 152 0 0 150 c0 83 -1 150 -3 150 -1 0 -70 -67 -152 -150z"></path>
                                      </g>
                                    </svg>
                                    <img
                                      class="ns-h-auto ns-object-contain"
                                      src={
                                        hit.imageUrl ?? productImagePlaceholder
                                      }
                                      alt={hit.name}
                                      width="60"
                                      height="40"
                                    />
                                  </div>
                                </a>
                              </div>

                              <div class="grid-product__meta-wrapper">
                                <a href={hit.url}>
                                  <div class="grid-product__meta">
                                    <div class="h5 text-bold grid-product__title grid-product__title--body">
                                      {hit.name}
                                    </div>
                                    {hit.brand && (
                                      <div class="grid-product__vendor">
                                        {hit.brand}
                                      </div>
                                    )}
                                    {/* Price */}
                                    <div class="grid-product__price">
                                      {hit.listPrice &&
                                        hit.listPrice > hit.price && (
                                          <>
                                            <span class="text-bold text-red ns-pr-1">
                                              <span class="money">
                                                {format(hit.price)}
                                              </span>
                                            </span>
                                            <span class="grid-product__price--original ns-text-striked">
                                              <span class="money">
                                                {format(hit.listPrice)}
                                              </span>
                                            </span>
                                          </>
                                        )}
                                      {hit.listPrice &&
                                        hit.listPrice === hit.price && (
                                          <span class="money">
                                            {format(hit.price)}
                                          </span>
                                        )}
                                    </div>
                                    {/* Price end  */}
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AutocompleteElement>
                  );
                })}
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// function Keyword({ hit }) {
//   return (
//     <span data-nosto-element="keyword">
//       {hit?._highlight?.keyword ? (
//         <span
//           dangerouslySetInnerHTML={{
//             __html: hit._highlight.keyword,
//           }}
//         ></span>
//       ) : (
//         hit.keyword
//       )}
//     </span>
//   );
// }

// function Element({ hit, keywordComponent, filter }) {
//   return (
//     <AutocompleteElement
//       hit={hit}
//       filter={filter}
//       class=""
//     >
//       {keywordComponent}
//     </AutocompleteElement>
//   );
// }

// function KeywordInCategory({ category, children }) {
//   return (
//     <span class="ns-clickable">
//       {category?.value ? (
//         <span>
//           {children}{' '}
//           <span class="ns-keyword-in-category">
//             in <span>{category.value}</span>
//           </span>
//         </span>
//       ) : (
//         children
//       )}
//     </span>
//   );
// }
